const getters = {
  hasTeacherPortalEnabled: state => state.enable_teacher_portal,
  has_ux_tester_role_enabled: state => state.has_ux_tester_role_enabled,
  enableVccCourseAndUnitReport: state => state.enable_vcc_course_and_unit_report,
};

export default getters;
